const getColorFromUrl = (url: string): string => {
  const matchString = url.match(/color\/[\w*|-]*/)
  return matchString?.[0].split('color/')[1] ?? ''
}

export default getColorFromUrl
